export const bypassCreditLimitEn = {
  BYPASS_CREDIT_LIMIT_HEADER: 'User allowed to bypass credit limit:',
  BYPASS_NO_BUY_HEADER: 'User allowed to bypass No Buy:',
  BYPASS_WARNING_DIALOG_TITLE: 'Are you sure you want to approve these invoices for funding?',
  BYPASS_WARNING_DIALOG_SUBTITLE: 'The following issues were detected:',
  BYPASS_WARNING_DIALOG_REVIEWED: 'Reviewed sections',
  BYPASS_WARNING_DIALOG_SECTIONS: 'Sections',
  BYPASS_WARNING_DIALOG_OPEN_ALL_HINT: 'Open every section to enable approval.',
  BYPASS_WARNING_DIALOG_SCROLL_HINT: 'Scroll to the end to enable approval.',
  BYPASS_WARNING_DIALOG_APPROVE_ANYWAY: 'Approve Anyway',
  BYPASS_NO_BUY_SECTION_TITLE: 'No Buy Restriction',
  BYPASS_NO_BUY_SECTION_DESCRIPTION: 'The following companies are marked as "No Buy":',
  BYPASS_CREDIT_LIMIT_SECTION_TITLE: 'Credit Limits Exceeded',
  BYPASS_CREDIT_LIMIT_SECTION_DESCRIPTION: 'The following companies will exceed their credit limit:',
  BYPASS_MAX_INVOICE_AMOUNT_SECTION_TITLE: 'Max Invoice Amount Bypass',
  BYPASS_MAX_INVOICE_AMOUNT_SECTION_DESCRIPTION: 'The following invoices exceed your regular approval limit:',
  BYPASS_CREDIT_LIMIT_METRIC: 'Credit limit',
  BYPASS_NEW_APPROVED_METRIC: 'New open amount',
  BYPASS_HYPHEN: '- ',
  BYPASS_CLIENT: 'Client ',
  BYPASS_BROKER: 'Broker ',
  BYPASS_DEBTOR: 'Debtor ',
  BYPASS_CREDIT_LIMIT: ' with Credit Limit: ',
  BYPASS_NO_BUY_ENABLED: ' has No Buy enabled.',
  BYPASS_CLIENT_DEBTOR_CREDIT_LIMIT: 'Client Debtor Credit Limit: ',
  BYPASS_BROKER_DEBTOR_CREDIT_LIMIT: 'Broker Debtor Credit Limit: ',
  BYPASS_NEW_APPROVED_AMOUNT: ', is going to have a new open amount of: ',
  BYPASS_AND: ' and ',
  BYPASS_RELATIONSHIP: 'The relationship between ',
}

export const bypassCreditLimitEs: typeof bypassCreditLimitEn = {
  BYPASS_CREDIT_LIMIT_HEADER: 'Usuario permitido para omitir el límite de crédito:',
  BYPASS_NO_BUY_HEADER: 'Usuario permitido para omitir No Buy:',
  BYPASS_WARNING_DIALOG_TITLE: '¿Está seguro de que desea aprobar estas facturas para financiamiento?',
  BYPASS_WARNING_DIALOG_SUBTITLE: 'Se detectaron los siguientes problemas:',
  BYPASS_WARNING_DIALOG_REVIEWED: 'Secciones revisadas',
  BYPASS_WARNING_DIALOG_SECTIONS: 'Secciones',
  BYPASS_WARNING_DIALOG_OPEN_ALL_HINT: 'Abre todas las secciones para habilitar la aprobación.',
  BYPASS_WARNING_DIALOG_SCROLL_HINT: 'Desplázate hasta el final para habilitar la aprobación.',
  BYPASS_WARNING_DIALOG_APPROVE_ANYWAY: 'Aprobar de todas formas',
  BYPASS_NO_BUY_SECTION_TITLE: 'Restricción No Buy',
  BYPASS_NO_BUY_SECTION_DESCRIPTION: 'Las siguientes compañías están marcadas como "No Buy":',
  BYPASS_CREDIT_LIMIT_SECTION_TITLE: 'Límites de crédito excedidos',
  BYPASS_CREDIT_LIMIT_SECTION_DESCRIPTION: 'Las siguientes compañías excederán su límite de crédito:',
  BYPASS_MAX_INVOICE_AMOUNT_SECTION_TITLE: 'Bypass de Monto Máximo de Factura',
  BYPASS_MAX_INVOICE_AMOUNT_SECTION_DESCRIPTION: 'Las siguientes facturas exceden tu límite de aprobación regular:',
  BYPASS_CREDIT_LIMIT_METRIC: 'Límite de crédito',
  BYPASS_NEW_APPROVED_METRIC: 'Nuevo monto abierto',
  BYPASS_HYPHEN: '- ',
  BYPASS_CLIENT: 'Cliente ',
  BYPASS_BROKER: 'Corredor ',
  BYPASS_DEBTOR: 'Deudor ',
  BYPASS_CREDIT_LIMIT: ' con Límite de Crédito: ',
  BYPASS_NO_BUY_ENABLED: ' tiene No Buy habilitado.',
  BYPASS_CLIENT_DEBTOR_CREDIT_LIMIT: 'Límite de crédito del cliente deudor: ',
  BYPASS_BROKER_DEBTOR_CREDIT_LIMIT: 'Límite de crédito del corredor deudor: ',
  BYPASS_NEW_APPROVED_AMOUNT: ', va a tener un nuevo monto abierto de: ',
  BYPASS_AND: ' y ',
  BYPASS_RELATIONSHIP: 'La relación entre ',
}
